import { API_BASE_URL } from "../../config"
import request from "../../utilities/request"

const issueAsset = (data) => request.post(`${API_BASE_URL}/blockchain/issue`, data)

export default issueAsset